(function () {
  const cfg = window.NAWAMobileConfig || {};
  const moneySymbol = cfg.moneySymbol || 'SAR ';

  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function shopifyRoute(path) {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : window.routes && window.routes.root
        ? window.routes.root
      : '/';
    return `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  }

  function localizedRoot() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : window.routes && window.routes.root
        ? window.routes.root
      : '/';
    return root.replace(/\/$/, '');
  }

  function localizeStaticLinks() {
    const selector = [
      '.bvc-mobile-shell a[href^="/collections/"]',
      '.bvc-mobile-shell a[href^="/pages/"]',
      '.bvc-mobile-shell a[href^="/policies/"]',
      '.nawa-desktop-global-nav a[href^="/collections/"]',
      '.nawa-desktop-global-nav a[href^="/pages/"]',
      '.nawa-desktop-home a[href^="/collections/"]',
      '.nawa-desktop-home a[href^="/pages/"]',
      '.nawa-desktop-collection-hero a[href^="/collections/"]',
      '.nawa-desktop-collection-hero a[href^="/pages/"]',
      '.nawa-desktop-product a[href^="/pages/"]',
    ].join(',');
    const root = localizedRoot();
    qsa(selector).forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || !/^\/(collections|pages|policies)\//.test(href)) return;
      if (!root || root === '/' || href === root || href.startsWith(`${root}/`)) return;
      link.setAttribute('href', `${root}${href}`);
    });
  }

  function formatMoney(cents) {
    if (window.NAWASARPricing && typeof window.NAWASARPricing.formatCents === 'function') {
      return window.NAWASARPricing.formatCents(cents);
    }
    const value = (Number(cents || 0) * 3.75) / 100;
    return `${moneySymbol}${value.toFixed(2)}`;
  }

  function currentConfig() {
    return window.NAWAMobileConfig || cfg || {};
  }

  function localizedPdpLabel(key, fallback, vars = {}, root = document) {
    const rootElement = root instanceof Element ? root : null;
    const queryRoot = root && typeof root.querySelector === 'function' ? root : document;
    const shell = (rootElement && rootElement.closest('[data-bvc-mobile-product]'))
      || qs('[data-bvc-mobile-product]', queryRoot)
      || qs('[data-bvc-mobile-product]');
    const attribute = `data-bvc-label-${String(key || '').replace(/_/g, '-')}`;
    let value = shell ? shell.getAttribute(attribute) : '';
    if (!value && window.NAWAI18n && typeof window.NAWAI18n.t === 'function') {
      value = window.NAWAI18n.t(fallback, vars);
    }
    if (!value) value = fallback;
    return Object.keys(vars).reduce((text, name) => {
      const token = `__${name.toUpperCase()}__`;
      return String(text)
        .split(token).join(String(vars[name]))
        .split(`{{ ${name} }}`).join(String(vars[name]));
    }, String(value || ''));
  }

  function localizedCartLabel(key, fallback, vars = {}, root = document) {
    const rootElement = root instanceof Element ? root : null;
    const queryRoot = root && typeof root.querySelector === 'function' ? root : document;
    const shell = (rootElement && rootElement.closest('[data-bvc-mobile-cart]'))
      || qs('[data-bvc-mobile-cart]', queryRoot)
      || qs('[data-bvc-mobile-cart]');
    const attribute = `data-bvc-cart-label-${String(key || '').replace(/_/g, '-')}`;
    let value = shell ? shell.getAttribute(attribute) : '';
    if (!value && window.NAWAI18n && typeof window.NAWAI18n.t === 'function') {
      value = window.NAWAI18n.t(fallback, vars);
    }
    if (!value) value = fallback;
    return Object.keys(vars).reduce((text, name) => {
      const token = `__${name.toUpperCase()}__`;
      return String(text)
        .split(token).join(String(vars[name]))
        .split(`{{ ${name} }}`).join(String(vars[name]));
    }, String(value || ''));
  }

  function getFreeShippingThresholdCents() {
    const node = qs('[data-bvc-free-shipping-threshold]');
    const dataValue = node ? Number(node.dataset.bvcFreeShippingThreshold || 0) : 0;
    const configValue = Number(currentConfig().freeShippingThresholdCents || 0);
    return Math.max(0, dataValue || configValue || 0);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeCartAssetUrl(value, fallback = '#') {
    const url = String(value || '');
    if (/^(https?:)?\/\//.test(url) || url.startsWith('/') || url.startsWith('#')) return escapeHtml(url);
    return fallback;
  }

  function wishlistLabels() {
    const labels = window.wishlist || {};
    return {
      add: labels.add || 'Add to wishlist',
      added: labels.added || 'Added to wishlist',
    };
  }

  function readWishlistItems() {
    try {
      const items = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
      return Array.isArray(items) ? items.filter(Boolean) : [];
    } catch {
      return [];
    }
  }

  function writeWishlistItems(items) {
    try {
      localStorage.setItem('wishlistItem', JSON.stringify(Array.from(new Set(items.filter(Boolean)))));
    } catch {
      // Wishlist falls back to the current page state if browser storage is unavailable.
    }
  }

  function syncWishlistButtons() {
    const items = readWishlistItems();
    const labels = wishlistLabels();
    qsa('[data-wishlist][data-wishlist-handle]').forEach((button) => {
      const active = items.includes(button.dataset.wishlistHandle);
      button.classList.toggle('wishlist-added', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? labels.added : labels.add);
      button.setAttribute('title', active ? labels.added : labels.add);
      const text = qs('.text', button);
      if (text) text.textContent = active ? labels.added : labels.add;
    });
    qsa('[data-wishlist-count]').forEach((node) => { node.textContent = items.length; });
  }

  function bindWishlistButtons() {
    if (document.documentElement.dataset.bvcWishlistBound) return;
    document.documentElement.dataset.bvcWishlistBound = 'true';

    syncWishlistButtons();

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist][data-wishlist-handle]');
      if (!button) return;

      if (window.wishlist && window.wishlist.show) {
        window.setTimeout(syncWishlistButtons, 0);
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      const handle = button.dataset.wishlistHandle;
      const items = readWishlistItems();
      const index = items.indexOf(handle);
      let added = false;
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.push(handle);
        added = true;
      }
      writeWishlistItems(items);
      if (added) {
        document.dispatchEvent(new CustomEvent('addwishlistitem', { detail: { handle }, bubbles: true }));
      } else {
        document.dispatchEvent(new CustomEvent('updatepagination', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('updatewishlistmail', { bubbles: true }));
      syncWishlistButtons();
    });

    window.addEventListener('storage', syncWishlistButtons);
    document.addEventListener('addwishlistitem', syncWishlistButtons);
    document.addEventListener('updatewishlistmail', syncWishlistButtons);
    document.addEventListener('updatepagination', syncWishlistButtons);
  }

  const layerSelector = '[data-bvc-filter-drawer], [data-bvc-sort-sheet], [data-bvc-variant-sheet], [data-bvc-pdp-option-sheet], [data-bvc-quick-cart], [data-bvc-confirm-sheet], [data-bvc-image-preview], [data-bvc-search-overlay], [data-bvc-review-page]';
  let layerHistoryActive = false;
  let activeLayerTrigger = null;
  const cartLineLocks = new Set();
  let selectedCheckoutPending = false;

  function setSearchBackgroundInert(overlay, inert) {
    qsa('body > *').forEach((node) => {
      if (node === overlay) return;
      if (inert && !node.inert) {
        node.inert = true;
        node.dataset.bvcSearchInert = 'true';
      } else if (!inert && node.dataset.bvcSearchInert === 'true') {
        node.inert = false;
        delete node.dataset.bvcSearchInert;
      }
    });
  }

  function anyOpenLayer() {
    return qsa(layerSelector).some((layer) => !layer.hidden);
  }

  function closeMobileLayers(options = {}) {
    const { skip = null, fromPop = false, updateHistory = true } = options;
    const hadOpen = anyOpenLayer();
    const searchOverlay = qs('[data-bvc-search-overlay]');
    qsa(layerSelector).forEach((layer) => {
      if (skip && layer === skip) return;
      layer.hidden = true;
    });
    if (!anyOpenLayer()) {
      document.body.classList.remove('bvc-layer-open');
      qsa('[data-bvc-search-overlay-open]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      if (searchOverlay) setSearchBackgroundInert(searchOverlay, false);
      if (!skip && activeLayerTrigger && activeLayerTrigger.isConnected) {
        const triggerToRestore = activeLayerTrigger;
        activeLayerTrigger = null;
        window.setTimeout(() => triggerToRestore.focus(), 0);
      }
    }
    if (hadOpen && !anyOpenLayer() && updateHistory && !fromPop && layerHistoryActive && window.history) {
      layerHistoryActive = false;
      window.history.back();
    }
  }

  function openMobileLayer(layer, trigger = null) {
    if (!layer) return;
    closeMobileLayers({ skip: layer, updateHistory: false });
    layer.hidden = false;
    document.body.classList.add('bvc-layer-open');
    if (trigger) activeLayerTrigger = trigger;
    if (layer.matches('[data-bvc-search-overlay]')) {
      setSearchBackgroundInert(layer, true);
      qsa('[data-bvc-search-overlay-open]').forEach((control) => control.setAttribute('aria-expanded', 'true'));
    }
    if (!layerHistoryActive && window.history && window.history.pushState) {
      window.history.pushState({ nawaMobileLayer: true }, '', window.location.href);
      layerHistoryActive = true;
    }
  }

  window.addEventListener('popstate', () => {
    if (!layerHistoryActive) return;
    layerHistoryActive = false;
    closeMobileLayers({ fromPop: true });
  });

  function ensureToast() {
    let toast = qs('[data-bvc-toast]');
    if (toast) return toast;
    toast = document.createElement('div');
    toast.className = 'bvc-toast';
    toast.hidden = true;
    toast.setAttribute('data-bvc-toast', '');
    const cartRoot = qs('[data-bvc-mobile-cart]');
    const viewCartLabel = escapeHtml(cartRoot
      ? localizedCartLabel('cart', 'Cart', {}, cartRoot)
      : localizedPdpLabel('view-cart', 'View Cart'));
    const continueLabel = escapeHtml(cartRoot
      ? localizedCartLabel('continue', 'Continue', {}, cartRoot)
      : localizedPdpLabel('continue', 'Continue'));
    toast.innerHTML = `<div><strong data-bvc-toast-title></strong><span data-bvc-toast-text></span></div><div class="bvc-toast-actions"><button type="button" data-bvc-cart-open>${viewCartLabel}</button><button type="button" data-bvc-toast-close>${continueLabel}</button></div>`;
    document.body.appendChild(toast);
    return toast;
  }

  let toastTimer = null;
  function showToast(title, text) {
    const toast = ensureToast();
    qs('[data-bvc-toast-title]', toast).textContent = title;
    qs('[data-bvc-toast-text]', toast).textContent = text || '';
    toast.hidden = false;
    qsa('[data-bvc-toast-close]', toast).forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => { toast.hidden = true; });
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => {
      toast.hidden = true;
    }, 3200);
  }

  function updateCartCount(count) {
    const safeCount = Math.max(0, Number(count) || 0);
    qsa('[data-bvc-cart-count]').forEach((node) => {
      node.textContent = safeCount;
      node.hidden = safeCount === 0;
    });
  }

  function cartRowQuantity(row) {
    return Math.max(0, Number(qs('.bvc-cart-qty span', row)?.textContent || row.dataset.bvcLineQuantity || 0));
  }

  async function fetchCart() {
    const response = await fetch(shopifyRoute('cart.js'), {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) throw new Error('Could not load cart');
    return response.json();
  }

  async function refreshCartCount() {
    const cart = await fetchCart();
    updateCartCount(cart.item_count);
    return cart;
  }

  async function postForm(form) {
    const data = new FormData(form);
    const response = await fetch(shopifyRoute('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data,
    });
    const text = await response.text();
    let body = {};
    try {
      body = text ? JSON.parse(text) : {};
    } catch {
      body = { text };
    }
    if (!response.ok) {
      if (response.status === 403 || /Verifying your connection|connection needs to be verified/i.test(body.text || '')) {
        throw new Error('Connection verification required. Refresh the page and try again.');
      }
      throw new Error(body.description || body.message || 'Could not add this item');
    }
    return body;
  }

  function bindSearchForms() {
    qsa('[data-bvc-search-form]').forEach((form) => {
      if (form.dataset.bvcBound) return;
      form.dataset.bvcBound = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = form.querySelector('input[name="q"]');
        const query = input ? input.value.trim() : '';
        const parts = [];
        if (query) parts.push(`q=${encodeURIComponent(query)}`);
        parts.push('type=product');
        parts.push('options%5Bprefix%5D=last');
        const current = new URLSearchParams(window.location.search);
        if (current.get('preview_theme_id')) {
          parts.push(`preview_theme_id=${encodeURIComponent(current.get('preview_theme_id'))}`);
        }
        const searchPath = form.getAttribute('action') || shopifyRoute('search');
        window.location.assign(`${searchPath}?${parts.join('&')}`);
      });
    });
  }

  function bindSearchOverlay() {
    const overlay = qs('[data-bvc-search-overlay]');
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    const overlayInput = qs('[data-bvc-search-overlay-input]', overlay);
    const overlayForm = qs('[data-bvc-search-overlay-form]', overlay);
    const historyList = qs('[data-bvc-search-history-list]', overlay);
    const historyEmpty = qs('[data-bvc-search-history-empty]', overlay);
    const historyClear = qs('[data-bvc-search-history-clear]', overlay);
    const historyKey = 'nawa-recent-searches';

    const readHistory = () => {
      try {
        const values = JSON.parse(window.localStorage.getItem(historyKey) || '[]');
        return Array.isArray(values) ? values.filter((value) => typeof value === 'string' && value.trim()).slice(0, 5) : [];
      } catch {
        return [];
      }
    };

    const writeHistory = (values) => {
      try {
        window.localStorage.setItem(historyKey, JSON.stringify(values));
      } catch {
        // Search still works when storage is unavailable.
      }
    };

    const renderHistory = () => {
      if (!historyList || !historyEmpty || !historyClear || !overlayForm) return;
      const values = readHistory();
      historyList.textContent = '';
      values.forEach((value) => {
        const link = document.createElement('a');
        const url = new URL(overlayForm.action, window.location.origin);
        url.searchParams.set('q', value);
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        link.href = url.toString();
        link.textContent = value;
        link.classList.add('notranslate');
        link.setAttribute('translate', 'no');
        link.setAttribute('data-nawa-i18n-skip', '');
        historyList.appendChild(link);
      });
      historyList.hidden = values.length === 0;
      historyEmpty.hidden = values.length > 0;
      historyClear.hidden = values.length === 0;
    };

    const valueFromTrigger = (trigger) => {
      if (!trigger || !trigger.matches) return '';
      if (trigger.matches('input[name="q"]')) return trigger.value || '';
      const form = trigger.closest('form');
      const formInput = form ? qs('input[name="q"]', form) : null;
      return formInput ? formInput.value || '' : '';
    };

    const openOverlay = (event) => {
      if (event && event.cancelable) event.preventDefault();
      const trigger = event ? event.currentTarget : null;
      const returnTrigger = trigger?.matches?.('input, textarea')
        ? qs('[data-bvc-search-overlay-open]:not(input):not(textarea)', trigger.closest('form') || document) || trigger
        : trigger;
      const value = valueFromTrigger(trigger).trim();
      if (overlayInput && value) overlayInput.value = value;
      renderHistory();
      openMobileLayer(overlay, returnTrigger);
      window.setTimeout(() => {
        if (!overlayInput) return;
        try {
          overlayInput.focus({ preventScroll: true });
        } catch {
          overlayInput.focus();
        }
      }, 50);
    };

    qsa('[data-bvc-search-overlay-open]').forEach((trigger) => {
      if (trigger.dataset.bvcSearchOverlayBound) return;
      trigger.dataset.bvcSearchOverlayBound = 'true';
      trigger.addEventListener('click', openOverlay);
      if (trigger.matches('input, textarea')) {
        trigger.addEventListener('focus', openOverlay);
      }
    });

    qsa('[data-bvc-search-overlay-close]', overlay).forEach((button) => {
      if (button.dataset.bvcSearchOverlayBound) return;
      button.dataset.bvcSearchOverlayBound = 'true';
      button.addEventListener('click', () => closeMobileLayers());
    });

    if (historyClear && !historyClear.dataset.bvcSearchOverlayBound) {
      historyClear.dataset.bvcSearchOverlayBound = 'true';
      historyClear.addEventListener('click', () => {
        writeHistory([]);
        renderHistory();
      });
    }

    if (overlayForm && !overlayForm.dataset.bvcSearchHistoryBound) {
      overlayForm.dataset.bvcSearchHistoryBound = 'true';
      overlayForm.addEventListener('submit', () => {
        const value = (overlayInput?.value || '').trim();
        if (!value) return;
        writeHistory([value, ...readHistory().filter((item) => item.toLowerCase() !== value.toLowerCase())].slice(0, 5));
      });
    }

    if (!overlay.dataset.bvcFocusTrapBound) {
      overlay.dataset.bvcFocusTrapBound = 'true';
      overlay.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', overlay)
          .filter((node) => !node.hidden && node.getClientRects().length);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }
  }

  function bindBackLinks() {
    qsa('[data-bvc-back]').forEach((link) => {
      if (link.dataset.bvcBound) return;
      link.dataset.bvcBound = 'true';
      link.addEventListener('click', (event) => {
        if (window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      });
    });
  }

  function syncPdpQuantities(form, sourceInput) {
    const quantityInputs = qsa('[data-bvc-pdp-sheet-quantity]', form);
    const mainQty = qs('[data-bvc-pdp-main-quantity]', form);
    if (!quantityInputs.length || !mainQty) return;
    const value = Math.max(1, Number((sourceInput || quantityInputs[0]).value || 1));
    quantityInputs.forEach((input) => { input.value = value; });
    mainQty.value = value;
  }

  function bindQuickAdd() {
    qsa('[data-bvc-quick-add-form], [data-bvc-product-form]').forEach((form) => {
      if (form.dataset.bvcBound) return;
      form.dataset.bvcBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.bvcSubmitting === 'true') return;
        form.dataset.bvcSubmitting = 'true';
        syncPdpQuantities(form);
        const button = event.submitter
          || (form.hasAttribute('data-bvc-product-form') ? qs('[data-bvc-pdp-add]', form) : null)
          || form.querySelector('button[type="submit"]');
        const buyNow = button && button.hasAttribute('data-bvc-buy-now');
        const original = button ? button.innerHTML : '';
        if (button) {
          button.disabled = true;
          button.textContent = buyNow
            ? localizedPdpLabel('preparing', 'Preparing...', {}, form)
            : localizedPdpLabel('adding', 'Adding...', {}, form);
        }
        try {
          await postForm(form);
          const cart = await refreshCartCount();
          showToast(
            buyNow
              ? localizedPdpLabel('going-to-checkout', 'Going to checkout', {}, form)
              : localizedPdpLabel('added-to-cart', 'Added to cart', {}, form),
            localizedPdpLabel('items-in-cart-template', 'Items in cart: __COUNT__', { count: cart.item_count }, form),
          );
          closeMobileLayers();
          if (buyNow) {
            window.location.href = shopifyRoute('checkout');
            return;
          }
        } catch (error) {
          showToast(localizedPdpLabel('could-not-add', 'Could not add', {}, form), error.message);
        } finally {
          delete form.dataset.bvcSubmitting;
          if (button) {
            button.disabled = false;
            button.innerHTML = original;
          }
        }
      });
    });
  }

  function bindVariantSheets() {
    qsa('[data-bvc-open-variant-sheet]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const sheet = document.getElementById(button.dataset.bvcOpenVariantSheet);
        if (sheet) {
          document.body.appendChild(sheet);
          openMobileLayer(sheet);
        }
      });
    });

    qsa('[data-bvc-open-pdp-options]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const sheet = qs('[data-bvc-pdp-option-sheet]');
        if (sheet) openMobileLayer(sheet);
      });
    });

    qsa('[data-bvc-close-sheet]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        closeMobileLayers();
      });
    });

    qsa('[data-bvc-close-pdp-options]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        closeMobileLayers();
      });
    });

    qsa('[data-bvc-select-sheet-variant]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const sheet = button.closest('[data-bvc-variant-sheet]');
        if (!sheet) return;
        qsa('[data-bvc-select-sheet-variant]', sheet).forEach((node) => node.classList.remove('is-selected'));
        button.classList.add('is-selected');
        const input = qs('[data-bvc-sheet-variant-id]', sheet);
        if (input) input.value = button.dataset.bvcSelectSheetVariant;
      });
    });
  }

  function bindDrawersAndSheets() {
    qsa('[data-bvc-open-filter]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const drawer = qs('[data-bvc-filter-drawer]');
        const sheet = qs('[data-bvc-sort-sheet]');
        if (sheet) sheet.hidden = true;
        if (drawer) openMobileLayer(drawer);
      });
    });

    qsa('[data-bvc-close-filter]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        closeMobileLayers();
      });
    });

    qsa('[data-bvc-open-sort]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const sheet = qs('[data-bvc-sort-sheet]');
        const drawer = qs('[data-bvc-filter-drawer]');
        if (drawer) drawer.hidden = true;
        if (sheet) openMobileLayer(sheet);
      });
    });

    qsa('[data-bvc-close-sort]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        closeMobileLayers();
      });
    });
  }

  function bindCategoryTabs() {
    qsa('[data-bvc-category-split]').forEach((wrap) => {
      if (wrap.dataset.bvcBound) return;
      wrap.dataset.bvcBound = 'true';
      wrap.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-bvc-category-tab]');
        if (!tab) return;
        const key = tab.dataset.bvcCategoryTab;
        qsa('[data-bvc-category-tab]', wrap).forEach((node) => node.classList.toggle('is-active', node === tab));
        qsa('[data-bvc-category-grid]', wrap).forEach((grid) => {
          grid.classList.toggle('is-active', grid.dataset.bvcCategoryGrid === key);
        });
        const title = qs('.bvc-category-head strong', wrap);
        if (title) title.textContent = tab.textContent.trim();
      });
    });
  }

  function bindDismissButtons() {
    if (document.documentElement.dataset.bvcDismissBound) return;
    document.documentElement.dataset.bvcDismissBound = 'true';
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bvc-dismiss-parent]');
      if (!button) return;
      const parent = button.parentElement;
      if (parent) parent.hidden = true;
    });
  }

  function bindLayerKeyboard() {
    if (document.documentElement.dataset.bvcLayerKeyboardBound) return;
    document.documentElement.dataset.bvcLayerKeyboardBound = 'true';
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && anyOpenLayer()) closeMobileLayers();
    });
  }

  function bindPdpVariants() {
    qsa('[data-bvc-product-form]').forEach((form) => {
      const variantsNode = qs('[data-bvc-product-variants]', form);
      if (!variantsNode || form.dataset.bvcVariantBound) return;
      form.dataset.bvcVariantBound = 'true';
      let variants = [];
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch {
        variants = [];
      }

      function selectedOptions() {
        const optionCount = variants[0] && variants[0].options ? variants[0].options.length : 0;
        return Array.from({ length: optionCount }).map((_, index) => {
          const groups = qsa('[data-bvc-option-index]', form).filter((group) => Number(group.dataset.bvcOptionIndex) === index);
          const selected = groups.map((group) => qs('.is-selected', group)).find(Boolean);
          return selected ? selected.dataset.value : '';
        });
      }

      function updateSelectedText(selected) {
        const omitSingleOptionName = selected.length === 1;
        const labels = selected.map((value, index) => {
          if (omitSingleOptionName) return value || '';
          const group = qsa('[data-bvc-option-index]', form).find((node) => Number(node.dataset.bvcOptionIndex) === index);
          const legend = qs('legend', group);
          const name = legend
            ? legend.textContent.trim()
            : localizedPdpLabel('option-template', 'Option __INDEX__', { index: index + 1 }, form);
          return `${name}: ${value || ''}`;
        }).filter((value) => value.trim() !== ':');
        qsa('[data-bvc-selected-options]', form).forEach((node) => {
          node.textContent = labels.join(', ');
        });
      }

      function variantMediaId(variant) {
        if (!variant) return '';
        if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
        if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
        return '';
      }

      function variantImageSrc(variant) {
        if (!variant) return '';
        if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
        if (variant.image) return variant.image;
        return '';
      }

      function rememberButtonLabels() {
        qsa('[data-bvc-pdp-add], [data-bvc-buy-now], [data-bvc-add-from-sheet]', form).forEach((button) => {
          if (button.dataset.bvcDefaultHtml) return;
          const availableLabel = button.dataset.bvcAvailableLabel;
          if (!availableLabel) {
            button.dataset.bvcDefaultHtml = button.innerHTML;
            return;
          }
          button.dataset.bvcDefaultHtml = button.hasAttribute('data-bvc-available-price')
            ? `<strong>${availableLabel}</strong><small data-bvc-buy-now-price></small>`
            : availableLabel;
        });
      }

      function actionButtons() {
        return qsa('[data-bvc-pdp-add], [data-bvc-buy-now], [data-bvc-add-from-sheet]', form);
      }

      function syncVariantPricing(variant) {
        if (!variant) return;
        const shell = form.closest('[data-bvc-mobile-product]') || form;
        const price = Math.max(0, Number(variant.price) || 0);
        const compareAt = Math.max(0, Number(variant.compare_at_price) || 0);
        const discounted = compareAt > price;
        const savings = discounted ? compareAt - price : 0;
        const discountPercent = discounted ? Math.round((savings * 100) / compareAt) : 0;

        qsa('[data-bvc-current-price]', shell).forEach((node) => { node.textContent = formatMoney(price); });
        qsa('[data-bvc-buy-now-price]', form).forEach((node) => { node.textContent = formatMoney(price); });
        qsa('[data-bvc-compare-price]', form).forEach((node) => { node.textContent = formatMoney(compareAt); });
        qsa('[data-bvc-discount-percent]', form).forEach((node) => { node.textContent = `-${discountPercent}%`; });
        qsa('[data-bvc-savings]', form).forEach((node) => {
          node.textContent = localizedPdpLabel('save-template', 'Save __AMOUNT__', { amount: formatMoney(savings) }, form);
        });
        qsa('[data-bvc-discount-only]', form).forEach((node) => { node.hidden = !discounted; });
        qsa('[data-bvc-availability]', form).forEach((node) => {
          const available = Boolean(variant.available);
          node.textContent = available
            ? (node.dataset.availableLabel || localizedPdpLabel('available', 'Available to order', {}, form))
            : (node.dataset.unavailableLabel || localizedPdpLabel('sold-out', 'Sold out', {}, form));
          node.classList.toggle('is-unavailable', !available);
        });
      }

      function syncUnavailableState() {
        const shell = form.closest('[data-bvc-mobile-product]') || form;
        const unavailableLabel = localizedPdpLabel('unavailable', 'Unavailable', {}, form);
        qsa('[data-bvc-current-price]', shell).forEach((node) => { node.textContent = unavailableLabel; });
        qsa('[data-bvc-buy-now-price]', form).forEach((node) => { node.textContent = ''; });
        qsa('[data-bvc-discount-only]', form).forEach((node) => { node.hidden = true; });
        qsa('[data-bvc-availability]', form).forEach((node) => {
          node.textContent = unavailableLabel;
          node.classList.add('is-unavailable');
        });
      }

      function syncVariantMedia(variant) {
        const imageSrc = variantImageSrc(variant);
        const mediaId = variantMediaId(variant);
        qsa('[data-bvc-option-image]', form).forEach((img) => {
          if (imageSrc) img.src = imageSrc;
        });
        if (!mediaId && !imageSrc) return;
        const mediaButtons = qsa('[data-bvc-preview-image]', form);
        const imageName = imageSrc ? imageSrc.split('?')[0].split('/').pop() : '';
        const active = mediaButtons.find((button) => {
          if (mediaId && button.dataset.bvcMediaId === mediaId) return true;
          return imageName && button.dataset.bvcPreviewImage && button.dataset.bvcPreviewImage.indexOf(imageName) !== -1;
        });
        if (!active) return;
        mediaButtons.forEach((button) => button.classList.toggle('is-active', button === active));
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      function syncVariantUrl(variant) {
        if (!variant || !variant.id || !form.closest('[data-bvc-mobile-product]')) return;
        if (!window.history || !window.history.replaceState) return;
        try {
          const url = new URL(window.location.href);
          if (!url.pathname.includes('/products/')) return;
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (error) {
          // URL sync is progressive enhancement; variant form state stays authoritative.
        }
      }

      function syncVariant() {
        rememberButtonLabels();
        const idInput = qs('[name="id"]', form);
        const optionGroups = qsa('[data-bvc-option-index]', form);
        const selected = optionGroups.length ? selectedOptions() : [];
        if (optionGroups.length) updateSelectedText(selected);
        const variant = optionGroups.length
          ? variants.find((item) => selected.every((value, index) => item.options[index] === value))
          : variants.find((item) => idInput && String(item.id) === String(idInput.value)) || variants[0];
        if (!variant) {
          if (idInput) idInput.value = '';
          actionButtons().forEach((button) => {
            button.disabled = true;
            button.textContent = localizedPdpLabel('unavailable', 'Unavailable', {}, form);
          });
          syncUnavailableState();
          return;
        }
        if (idInput) idInput.value = variant.id;
        syncVariantUrl(variant);
        syncVariantMedia(variant);
        actionButtons().forEach((button) => {
          button.disabled = !variant.available;
          if (!variant.available) {
            button.textContent = localizedPdpLabel('sold-out', 'Sold out', {}, form);
          } else if (button.dataset.bvcDefaultHtml) {
            button.innerHTML = button.dataset.bvcDefaultHtml;
          }
        });
        syncVariantPricing(variant);
      }

      qsa('[data-bvc-option-button]', form).forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-bvc-option-index]');
          const index = group ? group.dataset.bvcOptionIndex : '';
          qsa('[data-bvc-option-index]', form).filter((node) => node.dataset.bvcOptionIndex === index).forEach((node) => {
            qsa('[data-bvc-option-button]', node).forEach((optionButton) => {
              optionButton.classList.toggle('is-selected', optionButton.dataset.value === button.dataset.value);
            });
          });
          syncVariant();
        });
      });

      qsa('[data-bvc-two-sku-variant]', form).forEach((button) => {
        button.addEventListener('click', () => {
          let values = [];
          try {
            values = JSON.parse(button.dataset.bvcOptionValues || '[]');
          } catch {
            values = [];
          }
          values.forEach((value, index) => {
            qsa('[data-bvc-option-index]', form).filter((group) => Number(group.dataset.bvcOptionIndex) === index).forEach((group) => {
              qsa('[data-bvc-option-button]', group).forEach((optionButton) => {
                optionButton.classList.toggle('is-selected', optionButton.dataset.value === value);
              });
            });
          });
          qsa('[data-bvc-two-sku-variant]', form).forEach((node) => node.classList.toggle('is-selected', node === button));
          syncVariant();
        });
      });

      syncVariant();
    });
  }

  function bindQuantity() {
    qsa('[data-bvc-qty-minus], [data-bvc-qty-plus]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const wrap = button.closest('[data-bvc-quantity]');
        const input = wrap ? qs('input', wrap) : null;
        if (!input) return;
        const current = Math.max(1, Number(input.value || 1));
        input.value = button.hasAttribute('data-bvc-qty-plus') ? current + 1 : Math.max(1, current - 1);
        const form = button.closest('form');
        if (form) syncPdpQuantities(form, input);
      });
    });
  }

  function bindImagePreview() {
    let activeIndex = 0;

    function images() {
      return qsa('[data-bvc-preview-image]').map((button) => ({
        src: button.dataset.bvcPreviewImage,
        alt: button.getAttribute('aria-label') || localizedPdpLabel('product-image', 'Product image', {}, button),
      })).filter((item) => item.src);
    }

    function ensureViewer() {
      let viewer = qs('[data-bvc-image-preview]');
      if (viewer) return viewer;
      viewer = document.createElement('div');
      viewer.className = 'bvc-image-preview';
      viewer.hidden = true;
      viewer.setAttribute('data-bvc-image-preview', '');
      const closeLabel = escapeHtml(localizedPdpLabel('close-preview', 'Close preview'));
      const previousLabel = escapeHtml(localizedPdpLabel('previous-image', 'Previous image'));
      const nextLabel = escapeHtml(localizedPdpLabel('next-image', 'Next image'));
      viewer.innerHTML = `
        <button class="bvc-image-preview-close" type="button" data-bvc-close-preview aria-label="${closeLabel}">&times;</button>
        <div class="bvc-image-preview-counter" data-bvc-preview-counter></div>
        <button class="bvc-image-preview-nav is-prev" type="button" data-bvc-preview-prev aria-label="${previousLabel}">&lt;</button>
        <img alt="">
        <button class="bvc-image-preview-nav is-next" type="button" data-bvc-preview-next aria-label="${nextLabel}">&gt;</button>
      `;
      document.body.appendChild(viewer);
      qs('[data-bvc-close-preview]', viewer).addEventListener('click', () => { closeMobileLayers(); });
      viewer.addEventListener('click', (event) => {
        if (event.target === viewer) closeMobileLayers();
      });
      qs('[data-bvc-preview-prev]', viewer).addEventListener('click', () => render(activeIndex - 1));
      qs('[data-bvc-preview-next]', viewer).addEventListener('click', () => render(activeIndex + 1));
      return viewer;
    }

    function render(index) {
      const list = images();
      if (!list.length) return;
      activeIndex = (index + list.length) % list.length;
      const viewer = ensureViewer();
      const item = list[activeIndex];
      qs('img', viewer).src = item.src;
      qs('img', viewer).alt = item.alt;
      qs('[data-bvc-preview-counter]', viewer).textContent = `${activeIndex + 1}/${list.length}`;
      openMobileLayer(viewer);
    }

    function syncPdpGallery(gallery, explicitIndex) {
      if (!gallery) return;
      const shell = gallery.closest('[data-bvc-mobile-product]') || document;
      const mediaItems = qsa('[data-bvc-preview-index]', gallery);
      if (!mediaItems.length) return;
      const width = gallery.clientWidth || mediaItems[0].clientWidth || 1;
      const index = Number.isFinite(explicitIndex)
        ? explicitIndex
        : Math.round(gallery.scrollLeft / width);
      const safeIndex = Math.max(0, Math.min(mediaItems.length - 1, index));
      const count = qs('.bvc-pdp-count', shell);
      if (count) count.textContent = `${safeIndex + 1}/${mediaItems.length}`;
      qsa('[data-bvc-thumb-preview]', shell).forEach((node) => {
        node.classList.toggle('is-active', Number(node.dataset.bvcThumbIndex) === safeIndex);
      });
    }

    qsa('.bvc-pdp-v2-gallery').forEach((gallery) => {
      if (gallery.dataset.bvcGalleryBound) return;
      gallery.dataset.bvcGalleryBound = 'true';
      let frame = 0;
      const scheduleSync = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => syncPdpGallery(gallery));
      };
      gallery.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('resize', scheduleSync, { passive: true });
      syncPdpGallery(gallery, 0);
    });

    qsa('[data-bvc-preview-image]').forEach((button, index) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const explicitIndex = Number(button.dataset.bvcPreviewIndex);
        render(Number.isFinite(explicitIndex) ? explicitIndex : index);
      });
    });

    qsa('[data-bvc-thumb-preview]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const explicitIndex = Number(button.dataset.bvcThumbIndex);
        if (!Number.isFinite(explicitIndex)) return;
        const mediaButton = qs(`[data-bvc-preview-index="${explicitIndex}"]`);
        qsa('[data-bvc-thumb-preview]').forEach((node) => node.classList.toggle('is-active', node === button));
        if (mediaButton) {
          const gallery = mediaButton.closest('.bvc-pdp-v2-gallery');
          if (gallery && typeof mediaButton.scrollIntoView === 'function') {
            const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            mediaButton.scrollIntoView({
              behavior: reduceMotion ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'center',
            });
            syncPdpGallery(gallery, explicitIndex);
            return;
          }
          render(explicitIndex);
          return;
        }
        render(explicitIndex);
      });
    });
  }

  function renderQuickCartItem(item, index) {
    const image = item.image ? `<img src="${safeCartAssetUrl(item.image, '')}" alt="${escapeHtml(item.product_title)}">` : '<div class="bvc-cart-thumb">Image</div>';
    const variant = item.variant_title ? `<div class="bvc-cart-variant">${escapeHtml(item.variant_title)}</div>` : '';
    const itemUrl = safeCartAssetUrl(item.url);
    return `
      <div class="bvc-cart-row" data-bvc-cart-line="${index + 1}">
        ${image}
        <div>
          <a class="bvc-cart-row-title" href="${itemUrl}">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="bvc-cart-price">${formatMoney(item.final_line_price)}</div>
          <div class="bvc-cart-controls">
            <div class="bvc-cart-qty">
              <button type="button" data-bvc-cart-change="-1">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-bvc-cart-change="1">+</button>
            </div>
            <button class="bvc-cart-remove" type="button" data-bvc-cart-remove>Remove</button>
          </div>
        </div>
      </div>
    `;
  }

  function ensureQuickCart() {
    let cart = qs('[data-bvc-quick-cart]');
    if (cart) return cart;
    cart = document.createElement('div');
    cart.className = 'bvc-quick-cart';
    cart.hidden = true;
    cart.setAttribute('data-bvc-quick-cart', '');
    cart.innerHTML = `
      <button class="bvc-quick-cart-overlay" type="button" data-bvc-close-quick-cart aria-label="Close cart"></button>
      <div class="bvc-quick-cart-panel">
        <div class="bvc-cart-head">
          <strong>Cart</strong>
          <button class="bvc-close-button" type="button" data-bvc-close-quick-cart aria-label="Close cart">&times;</button>
        </div>
        <div data-bvc-quick-cart-content></div>
      </div>
    `;
    document.body.appendChild(cart);
    qsa('[data-bvc-close-quick-cart]', cart).forEach((button) => {
      button.addEventListener('click', () => { closeMobileLayers(); });
    });
    return cart;
  }

  function renderQuickCart(cart) {
    const shell = ensureQuickCart();
    const content = qs('[data-bvc-quick-cart-content]', shell);
    if (!cart.items.length) {
      content.innerHTML = `
        <div class="bvc-empty-card">
          <div>
            <strong>Your cart is empty</strong>
            <p>Browse best sellers or search for a product to start.</p>
            <div class="bvc-button-row">
              <a class="bvc-button" href="${shopifyRoute('collections/best-sellers')}">Best Sellers</a>
              <a class="bvc-button is-secondary" href="${shopifyRoute('collections/all')}">All Categories</a>
            </div>
          </div>
        </div>
      `;
      return;
    }
    const threshold = getFreeShippingThresholdCents();
    const remaining = Math.max(threshold - cart.total_price, 0);
    const progress = threshold > 0 ? Math.min(100, Math.round((cart.total_price / threshold) * 100)) : 100;
    const deliveryProgress = threshold > 0
      ? `<div class="bvc-free-shipping">
          <strong>${remaining === 0 ? 'Free delivery unlocked' : `Add ${formatMoney(remaining)} for free delivery`}</strong>
          <div class="bvc-progress"><span style="width:${progress}%"></span></div>
        </div>`
      : `<div class="bvc-free-shipping"><strong>Delivery costs and eligibility are confirmed before checkout</strong></div>`;
    content.innerHTML = `
      <div class="bvc-quick-cart-items">
        ${cart.items.map(renderQuickCartItem).join('')}
      </div>
      ${deliveryProgress}
      <div class="bvc-cart-sticky">
        <div><small>Total</small><strong>${formatMoney(cart.total_price)}</strong></div>
        <a href="${shopifyRoute('checkout')}">Checkout</a>
      </div>
    `;
  }

  async function openQuickCart() {
    try {
      const cart = await fetchCart();
      updateCartCount(cart.item_count);
      renderQuickCart(cart);
      openMobileLayer(ensureQuickCart());
    } catch (error) {
      showToast('Cart unavailable', error.message);
    }
  }

  function bindQuickCart() {
    document.addEventListener('click', async (event) => {
      const open = event.target.closest('[data-bvc-cart-open]');
      if (open) {
        event.preventDefault();
        window.location.href = open.getAttribute('href') || shopifyRoute('cart');
        return;
      }

      const cartRow = event.target.closest('[data-bvc-cart-line]');
      if (!cartRow) return;
      const line = Number(cartRow.dataset.bvcCartLine);
      if (event.target.closest('[data-bvc-cart-change]')) {
        const delta = Number(event.target.closest('[data-bvc-cart-change]').dataset.bvcCartChange);
        const qty = Number(qs('.bvc-cart-qty span', cartRow)?.textContent || 0);
        await changeCartLine(line, Math.max(0, qty + delta));
      }
      if (event.target.closest('[data-bvc-cart-remove]')) {
        await changeCartLine(line, 0);
      }
    });
  }

  async function changeCartLine(line, quantity) {
    if (cartLineLocks.has(line)) return;
    cartLineLocks.add(line);
    const activeRow = qs(`[data-bvc-cart-line="${line}"]`);
    if (activeRow) {
      activeRow.setAttribute('aria-busy', 'true');
      qsa('[data-bvc-cart-change], [data-bvc-cart-remove]', activeRow).forEach((button) => { button.disabled = true; });
    }
    try {
      const response = await fetch(shopifyRoute('cart/change.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ line, quantity }),
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || localizedCartLabel('could-not-update', 'Could not update cart'));
      updateCartCount(cart.item_count);
      const quickCart = qs('[data-bvc-quick-cart]');
      if (quickCart && !quickCart.hidden) renderQuickCart(cart);
      const refreshedCartPage = await refreshCartPageSection();
      if (refreshedCartPage) {
        showToast(
          localizedCartLabel('updated', 'Cart updated'),
          localizedCartLabel('items-in-cart-template', '__COUNT__ items in cart', { count: cart.item_count }),
        );
        return;
      }
      const row = qs(`[data-bvc-cart-line="${line}"]`);
      const item = cart.items[line - 1];
      if (row && quantity === 0) {
        row.remove();
      } else if (row && item) {
        const qty = qs('.bvc-cart-qty span', row);
        const price = qs('.bvc-cart-price', row);
        row.dataset.bvcLinePrice = item.final_line_price;
        row.dataset.bvcLineOriginal = item.original_line_price || item.final_line_price;
        row.dataset.bvcLineQuantity = item.quantity;
        if (qty) qty.textContent = item.quantity;
        if (price) price.textContent = formatMoney(item.final_price);
      }
      qsa('[data-bvc-cart-subtotal]').forEach((node) => { node.textContent = formatMoney(cart.total_price); });
      syncCartSelection();
      showToast(
        localizedCartLabel('updated', 'Cart updated'),
        localizedCartLabel('items-in-cart-template', '__COUNT__ items in cart', { count: cart.item_count }),
      );
    } catch (error) {
      showToast(localizedCartLabel('update-failed', 'Cart update failed'), error.message);
    } finally {
      cartLineLocks.delete(line);
      const row = qs(`[data-bvc-cart-line="${line}"]`);
      if (row) {
        row.removeAttribute('aria-busy');
        qsa('[data-bvc-cart-change], [data-bvc-cart-remove]', row).forEach((button) => { button.disabled = false; });
      }
    }
  }

  async function refreshCartPageSection() {
    const currentRoot = qs('[data-bvc-mobile-cart]');
    if (!currentRoot || !window.DOMParser) return false;
    const selectedByKey = new Map(
      qsa('[data-bvc-cart-line]', currentRoot)
        .filter((row) => row.dataset.bvcCartKey)
        .map((row) => [
          row.dataset.bvcCartKey,
          Boolean(qs('[data-bvc-cart-select]', row)?.classList.contains('is-selected')),
        ]),
    );
    const sectionId = currentRoot.dataset.bvcSectionId || 'bvc_mobile_cart';
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(localizedCartLabel('could-not-refresh', 'Could not refresh cart section', {}, currentRoot));
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextRoot = qs('[data-bvc-mobile-cart]', doc) || doc.body.firstElementChild;
      if (!nextRoot) return false;
      currentRoot.replaceWith(nextRoot);
      qsa('[data-bvc-cart-line]', nextRoot).forEach((row) => {
        const select = qs('[data-bvc-cart-select]', row);
        if (!select || !selectedByKey.has(row.dataset.bvcCartKey)) return;
        select.classList.toggle('is-selected', selectedByKey.get(row.dataset.bvcCartKey));
      });
      bindQuickAdd();
      bindVariantSheets();
      bindCartSelection();
      syncCartSelection();
      return true;
    } catch (error) {
      showToast(localizedCartLabel('refresh-failed', 'Cart refresh failed'), error.message);
      return false;
    }
  }

  function syncCartSelection() {
    const cartRoot = qs('[data-bvc-mobile-cart]');
    if (!cartRoot) return;
    const rows = qsa('[data-bvc-cart-line]', cartRoot);
    let selected = 0;
    let selectedRows = 0;
    let totalQuantity = 0;
    let total = 0;
    let original = 0;
    rows.forEach((row) => {
      const select = qs('[data-bvc-cart-select]', row);
      const isSelected = !select || select.classList.contains('is-selected');
      if (select) select.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      const quantity = cartRowQuantity(row);
      totalQuantity += quantity;
      row.classList.toggle('is-selected', isSelected);
      if (!isSelected) return;
      selectedRows += 1;
      selected += quantity;
      total += Number(row.dataset.bvcLinePrice || 0);
      original += Number(row.dataset.bvcLineOriginal || row.dataset.bvcLinePrice || 0);
    });

    qsa('[data-bvc-selected-count]').forEach((node) => { node.textContent = selected; });
    qsa('[data-bvc-cart-heading-count], [data-bvc-cart-all-count]').forEach((node) => { node.textContent = totalQuantity; });
    qsa('[data-bvc-cart-subtotal]').forEach((node) => { node.textContent = formatMoney(total); });
    qsa('[data-bvc-original-total]').forEach((node) => { node.textContent = formatMoney(original); });
    qsa('[data-bvc-selected-saving]').forEach((node) => {
      node.textContent = `Applied ${formatMoney(Math.max(original - total, 0))} off`;
    });

    const all = qs('[data-bvc-cart-select-all]', cartRoot);
    if (all) {
      const allSelected = rows.length > 0 && selectedRows === rows.length;
      all.classList.toggle('is-selected', allSelected);
      all.setAttribute('aria-pressed', allSelected ? 'true' : 'false');
    }

    const checkout = qs('[data-bvc-selected-checkout]', cartRoot);
    if (checkout) {
      checkout.classList.toggle('is-disabled', selected === 0);
      checkout.setAttribute('aria-disabled', selected === 0 ? 'true' : 'false');
    }
  }

  function ensureConfirmSheet() {
    let sheet = qs('[data-bvc-confirm-sheet]');
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'bvc-confirm-sheet';
    sheet.hidden = true;
    sheet.setAttribute('data-bvc-confirm-sheet', '');
    sheet.innerHTML = `
      <button class="bvc-sheet-overlay" type="button" data-bvc-confirm-cancel aria-label="${escapeHtml(localizedCartLabel('confirm-cancel', 'Cancel checkout'))}"></button>
      <div class="bvc-confirm-panel">
        <strong>${escapeHtml(localizedCartLabel('confirm-title', 'Checkout selected items?'))}</strong>
        <p data-bvc-confirm-copy></p>
        <div class="bvc-confirm-actions">
          <button type="button" data-bvc-confirm-cancel>${escapeHtml(localizedCartLabel('cancel', 'Cancel'))}</button>
          <button type="button" data-bvc-confirm-continue>${escapeHtml(localizedCartLabel('continue', 'Continue'))}</button>
        </div>
      </div>
    `;
    document.body.appendChild(sheet);
    return sheet;
  }

  function confirmSelectedCheckout(selectedCount, removedCount) {
    if (!removedCount) return Promise.resolve(true);
    return new Promise((resolve) => {
      const sheet = ensureConfirmSheet();
      const copy = qs('[data-bvc-confirm-copy]', sheet);
      if (copy) {
        copy.textContent = localizedCartLabel(
          'confirm-copy-template',
          'You selected __SELECTED__ items. __REMOVED__ unselected items will be removed from this cart before checkout.',
          { selected: selectedCount, removed: removedCount },
        );
      }
      const finish = (value) => {
        closeMobileLayers();
        resolve(value);
      };
      qsa('[data-bvc-confirm-cancel]', sheet).forEach((button) => {
        button.onclick = () => finish(false);
      });
      const continueButton = qs('[data-bvc-confirm-continue]', sheet);
      if (continueButton) continueButton.onclick = () => finish(true);
      openMobileLayer(sheet);
    });
  }

  function bindCartSelection() {
    const cartRoot = qs('[data-bvc-mobile-cart]');
    if (!cartRoot || cartRoot.dataset.bvcSelectionBound) return;
    cartRoot.dataset.bvcSelectionBound = 'true';

    cartRoot.addEventListener('click', async (event) => {
      const select = event.target.closest('[data-bvc-cart-select]');
      if (select) {
        event.preventDefault();
        select.classList.toggle('is-selected');
        syncCartSelection();
        return;
      }

      const selectAll = event.target.closest('[data-bvc-cart-select-all]');
      if (selectAll) {
        event.preventDefault();
        const next = !selectAll.classList.contains('is-selected');
        qsa('[data-bvc-cart-select]', cartRoot).forEach((button) => {
          button.classList.toggle('is-selected', next);
        });
        syncCartSelection();
        return;
      }

      const checkout = event.target.closest('[data-bvc-selected-checkout]');
      if (!checkout) return;
      if (!qs('[data-bvc-cart-select]', cartRoot)) return;
      if (selectedCheckoutPending) {
        event.preventDefault();
        return;
      }
      const rows = qsa('[data-bvc-cart-line]', cartRoot);
      const selectedRows = rows.filter((row) => qs('[data-bvc-cart-select]', row)?.classList.contains('is-selected'));
      if (!selectedRows.length) {
        event.preventDefault();
        showToast(
          localizedCartLabel('select-first', 'Select items first'),
          localizedCartLabel('choose-item', 'Choose at least one item before checkout.'),
        );
        return;
      }
      const unselectedRows = rows.filter((row) => !qs('[data-bvc-cart-select]', row)?.classList.contains('is-selected'));
      if (!unselectedRows.length) return;

      event.preventDefault();
      const selectedQuantity = selectedRows.reduce((sum, row) => sum + cartRowQuantity(row), 0);
      const unselectedQuantity = unselectedRows.reduce((sum, row) => sum + cartRowQuantity(row), 0);
      const confirmed = await confirmSelectedCheckout(selectedQuantity, unselectedQuantity);
      if (!confirmed) return;
      const updates = {};
      unselectedRows.forEach((row) => {
        if (row.dataset.bvcCartKey) updates[row.dataset.bvcCartKey] = 0;
      });
      try {
        selectedCheckoutPending = true;
        checkout.classList.add('is-loading');
        checkout.setAttribute('aria-busy', 'true');
        const response = await fetch(shopifyRoute('cart/update.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ updates }),
        });
        if (!response.ok) throw new Error(localizedCartLabel('could-not-prepare', 'Could not prepare selected checkout'));
        window.location.href = checkout.getAttribute('href') || shopifyRoute('checkout');
      } catch (error) {
        showToast(localizedCartLabel('checkout-unavailable', 'Checkout unavailable'), error.message);
        selectedCheckoutPending = false;
        checkout.classList.remove('is-loading');
        checkout.removeAttribute('aria-busy');
      }
    });

    syncCartSelection();
  }

  function bindPdpUi() {
    qsa('.bvc-pdp-tabs-v2 a').forEach((link) => {
      if (link.dataset.bvcBound) return;
      link.dataset.bvcBound = 'true';
      link.addEventListener('click', (event) => {
        const target = qs(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        qsa('.bvc-pdp-tabs-v2 a').forEach((node) => node.classList.toggle('is-active', node === link));
        const top = target.getBoundingClientRect().top + window.scrollY - 56;
        window.scrollTo({ top, behavior: 'smooth' });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', link.getAttribute('href'));
        }
      });
    });

    qsa('[data-bvc-title-toggle]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const titleScope = button.closest('.bvc-pdp-v2-card') || button.closest('[data-bvc-mobile-product]') || document;
        const title = qs('[data-bvc-title-text]', titleScope) || qs('.bvc-pdp-title', button);
        if (!title) return;
        const expanded = !title.classList.contains('is-expanded');
        title.classList.toggle('is-expanded', expanded);
        button.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
      });
    });

    qsa('[data-bvc-share]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', async () => {
        try {
          if (navigator.share) {
            await navigator.share({ title: document.title, url: window.location.href });
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(window.location.href);
            showToast(
              localizedPdpLabel('link-copied', 'Link copied', {}, button),
              localizedPdpLabel('product-link-copied', 'Product link copied to clipboard.', {}, button),
            );
          }
        } catch {
          showToast(
            localizedPdpLabel('share-unavailable', 'Share unavailable', {}, button),
            localizedPdpLabel('copy-url', 'You can copy the URL from your browser.', {}, button),
          );
        }
      });
    });

    qsa('[data-bvc-pdp-sheet-quantity]').forEach((input) => {
      if (input.dataset.bvcBound) return;
      input.dataset.bvcBound = 'true';
      input.addEventListener('change', () => {
        const form = input.closest('form');
        if (form) syncPdpQuantities(form, input);
      });
    });

    qsa('[data-bvc-story-toggle]').forEach((button) => {
      if (button.dataset.bvcBound) return;
      button.dataset.bvcBound = 'true';
      button.addEventListener('click', () => {
        const section = button.closest('.bvc-pdp-description-v2');
        const copy = section ? qs('[data-bvc-story-copy]', section) : null;
        if (!copy) return;
        const expanded = !copy.classList.contains('is-expanded');
        copy.classList.toggle('is-expanded', expanded);
        button.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        const label = qs('[data-bvc-story-toggle-label]', button);
        if (label) {
          label.textContent = expanded
            ? (button.dataset.collapseLabel || localizedPdpLabel('show-less', 'Show less', {}, button))
            : (button.dataset.expandLabel || localizedPdpLabel('show-more', 'Show more', {}, button));
        }
      });
    });
  }

  function bindPdpPurchaseDocking() {
    qsa('.bvc-pdp-approved-v2').forEach((shell) => {
      if (shell.dataset.bvcPurchaseDockBound) return;
      const purchase = qs('.bvc-pdp-approved-purchase', shell);
      if (!purchase) return;
      shell.dataset.bvcPurchaseDockBound = 'true';

      let scheduled = false;
      const sync = () => {
        scheduled = false;
        shell.classList.toggle('is-purchase-docked', purchase.getBoundingClientRect().bottom <= 0);
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(sync);
      };

      shell.classList.add('is-purchase-dock-ready');
      sync();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    });
  }

  function bindVideoPosterFallback() {
    if (document.documentElement.dataset.nawaVideoPosterFallbackBound) return;
    document.documentElement.dataset.nawaVideoPosterFallbackBound = 'true';
    document.addEventListener('error', (event) => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement)) return;
      const fallback = image.dataset.nawaPosterFallback;
      if (!fallback || image.dataset.nawaPosterFallbackUsed === 'true') return;
      image.dataset.nawaPosterFallbackUsed = 'true';
      image.classList.add('is-product-poster');
      image.src = fallback;
    }, true);
  }

  function syncTrustooReviewPreview(source) {
    if (!source) return;
    const summary = window.vstar_product_rating || {};
    const totalReviews = Math.max(0, Number(summary.total_reviews) || 0);
    const rating = Number.parseFloat(summary.rating);
    qsa('[data-bvc-review-rating]').forEach((node) => {
      node.textContent = totalReviews > 0 && Number.isFinite(rating)
        ? rating.toFixed(1)
        : localizedPdpLabel('customer-reviews', 'Customer reviews', {}, node);
    });
    qsa('[data-bvc-review-count]').forEach((node) => { node.textContent = String(totalReviews); });
    qsa('[data-bvc-review-stars]').forEach((node) => { node.hidden = totalReviews === 0; });
    qsa('[data-bvc-review-ready]').forEach((node) => { node.hidden = totalReviews === 0; });
    qsa('[data-bvc-review-zero]').forEach((node) => { node.hidden = totalReviews > 0; });

    const reviewPage = qs('[data-bvc-review-page]');
    const pageCountNode = qs('[data-bvc-review-page-count]');
    if (reviewPage) reviewPage.dataset.bvcReviewState = totalReviews > 0 ? 'ready' : 'empty';
    if (pageCountNode) {
      const template = pageCountNode.dataset.bvcReviewCountTemplate
        || localizedPdpLabel('review-count-template', '__COUNT__ reviews', { count: '__COUNT__' }, pageCountNode);
      pageCountNode.textContent = template.replace('__COUNT__', String(totalReviews));
      pageCountNode.hidden = totalReviews === 0;
    }

    const previewList = qs('[data-bvc-review-preview-list]');
    const reviews = qsa('.list-review', source).slice(0, 2);
    if (!previewList) return;
    previewList.textContent = '';
    if (!reviews.length) return;
    const fragment = document.createDocumentFragment();
    reviews.forEach((review) => {
      const name = qs('.author-name, .user-name', review)?.textContent?.trim() || '';
      const verified = qs('.verified-text, .user-verified', review)?.textContent?.trim() || '';
      const body = qs('.reviews-text', review)?.textContent?.trim();
      if (!body) return;
      const article = document.createElement('article');
      if (name || verified) {
        const meta = document.createElement('div');
        meta.className = 'bvc-review-preview-meta';
        if (name) {
          const avatar = document.createElement('span');
          avatar.textContent = name.charAt(0).toUpperCase();
          const nameNode = document.createElement('b');
          nameNode.textContent = name;
          meta.append(avatar, nameNode);
        }
        if (verified) {
          const verifiedNode = document.createElement('small');
          verifiedNode.textContent = verified;
          meta.appendChild(verifiedNode);
        }
        article.appendChild(meta);
      }
      const paragraph = document.createElement('p');
      paragraph.textContent = body;
      article.appendChild(paragraph);
      fragment.appendChild(article);
    });
    if (!fragment.childNodes.length) return;
    previewList.appendChild(fragment);
  }

  function mountTrustooReviews() {
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return false;
    const target = qs('[data-bvc-trustoo-reviews]');
    const source = qs('#trustoo-widget-wrapper');
    if (!target || !source) return Boolean(source && target);
    if (!target.contains(source)) target.appendChild(source);
    const loading = qs('[data-bvc-trustoo-loading]');
    const error = qs('[data-bvc-trustoo-error]');
    if (loading) loading.hidden = true;
    if (error) error.hidden = true;
    if (!source.dataset.bvcPreviewObserved) {
      source.dataset.bvcPreviewObserved = 'true';
      const observer = new MutationObserver(() => syncTrustooReviewPreview(source));
      observer.observe(source, { childList: true, subtree: true, characterData: true });
    }
    syncTrustooReviewPreview(source);
    return true;
  }

  function bindTrustooReviews() {
    if (!qs('[data-bvc-trustoo-reviews]') || document.documentElement.dataset.bvcTrustooBound) return;
    document.documentElement.dataset.bvcTrustooBound = 'true';
    if (mountTrustooReviews()) return;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (mountTrustooReviews()) {
        window.clearInterval(timer);
        return;
      }
      if (attempts > 20) {
        window.clearInterval(timer);
        const loading = qs('[data-bvc-trustoo-loading]');
        const error = qs('[data-bvc-trustoo-error]');
        const page = qs('[data-bvc-review-page]');
        if (loading) loading.hidden = true;
        if (error) error.hidden = false;
        if (page) page.dataset.bvcReviewState = 'error';
      }
    }, 500);
  }

  function bindReviewPage() {
    if (document.documentElement.dataset.bvcReviewPageBound) return;
    document.documentElement.dataset.bvcReviewPageBound = 'true';

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const openButton = target?.closest('[data-bvc-review-open]');
      if (openButton) {
        const page = qs('[data-bvc-review-page]');
        if (!page) return;
        event.preventDefault();
        mountTrustooReviews();
        openMobileLayer(page, openButton);
        page.scrollTop = 0;
        window.requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
          qs('[data-bvc-review-close]', page)?.focus();
        });
        return;
      }
      const closeButton = target?.closest('[data-bvc-review-close]');
      if (closeButton) {
        event.preventDefault();
        const reviewTarget = closeButton.getAttribute('data-bvc-review-target');
        closeMobileLayers();
        if (reviewTarget) {
          window.requestAnimationFrame(() => {
            qs(reviewTarget)?.scrollIntoView({
              behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start',
            });
          });
        }
      }
    });
  }

  function init() {
    localizeStaticLinks();
    bindBackLinks();
    bindSearchForms();
    bindSearchOverlay();
    bindQuickAdd();
    bindVariantSheets();
    bindDrawersAndSheets();
    bindCategoryTabs();
    bindDismissButtons();
    bindLayerKeyboard();
    bindPdpVariants();
    bindQuantity();
    bindImagePreview();
    bindCartSelection();
    bindQuickCart();
    bindPdpUi();
    bindPdpPurchaseDocking();
    bindWishlistButtons();
    bindVideoPosterFallback();
    bindTrustooReviews();
    bindReviewPage();
    refreshCartCount().catch(() => {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
